import LandingB2B from "./pages/LandingB2B";

export default function App() {
  return <LandingB2B />;
}
